const api = "https://siteapi.kurr.com/api/kurdiagnostic/send-email";
module.exports = { api };
